import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import clsx from 'clsx';

import { useGetDevelopmentStageData } from 'components/OnePageTemplates/helpers/getDevelopmentStageData';

import { IDevelopmentStagesProps as IProps } from './types';

import styles from './DevelopmentStages.module.scss';

export const DevelopmentStages: FC<IProps> = ({ selectedStage }) => {
  const { i18n, t } = useTranslation();
  const stages = useGetDevelopmentStageData(i18n.language);
  return (
    <Box className={styles.wrapper}>
      <Box className={styles.title}>{t('onePageMapping.devStage')}</Box>
      <Box className={styles.container}>
        {stages.map(({ label, value }) => (
          <Box className={clsx(styles.stage, { [styles.stageActive]: selectedStage.includes(value) })} key={label}>
            {label}
          </Box>
        ))}
      </Box>
    </Box>
  );
};
